import _mergeJSXProps from "@vue/babel-helper-vue-jsx-merge-props";
// Types
import mixins from "vue-typed-mixins";
export const GboxMediaUploadModalEvents = typedModal();
// Enums
import { Modals } from '../../enums/Modals';

// Utils
import { typedModal } from '../../utils/typedModals';
import { preventDefault } from '../../utils/jsxHelpers';

// Mixins
import { WithRefs } from '../../utils/withRefs';

// Components
import AdminButton from '../ui/AdminButton';
import CmsSpinner from '../ui/CmsSpinner';
// Main
const GboxMediaUpload = mixins(WithRefs(), GboxMediaUploadModalEvents).extend({
  data() {
    return {
      // form: {
      //   title: '',
      //   description: '',
      // },
      uploadProgress: null,
      loading: false,
      uploadProgresses: []
    };
  },
  methods: {
    resetForm() {
      this.uploadProgress = null;
      // this.form.title = ''
      // this.form.description = ''
    },

    async readFile(file) {
      const promise = new Promise((resolve, reject) => {
        const onFileReaderLoad = e => {
          var _e$target;
          if (!((_e$target = e.target) !== null && _e$target !== void 0 && _e$target.result)) {
            reject({
              message: this.$t('error.readFile', {
                entity: file.name
              })
            });
          } else resolve({
            file: e.target.result
          });
        };
        const fileReader = new FileReader();
        fileReader.readAsArrayBuffer(file);
        fileReader.onload = onFileReaderLoad;
      });
      return promise;
    },
    async readAllFiles(files) {
      const fileReaderPromises = files.map(file => this.readFile(file));
      try {
        const fileReaderResponses = await Promise.all(fileReaderPromises);
        return fileReaderResponses;
      } catch (e) {
        this.$toast.error(e.message);
        return;
      }
    },
    async uploadFilesToBucket(files, convertedFiles, uploadUrls) {
      if (uploadUrls.errored) return;
      const uploadToBucketPromises = uploadUrls.data.map((uploadUrl, index) => {
        const url = uploadUrl.url;
        const realUrl = typeof url === 'string' ? url : url.url;

        // @ts-ignore
        const convertedFile = convertedFiles[index].file;
        return this.$axios.put(realUrl, convertedFile, {
          headers: {
            'Content-Type': 'application/octet-stream'
          },
          onUploadProgress: progressEvent => {
            // if (!progressEvent.lengthComputable) return
            // const uploadPercent =
            //   (progressEvent.loaded / progressEvent.total) * 100
            //
            // this.progress = Math.floor(uploadPercent)
          }
        });
      });
      try {
        const uploadToBucketResponses = await Promise.all(uploadToBucketPromises);
        return uploadToBucketResponses;
      } catch (e) {
        this.$toast.error(e.message);
        return;
      }
    },
    async addFromBucketToMedia(files, uploadUrls) {
      if (uploadUrls.errored) return;
      const addFromBucketReqBody = uploadUrls.data.map((uploadUrl, index) => {
        const filename = files[index].name;
        return {
          filename,
          path: uploadUrl.path,
          isPublic: true,
          customData: {
            directoryId: 'cms',
            access: 'public',
            resize: true,
            title: filename,
            description: filename
          }
        };
      });
      return await this.$api.media.file.addFromBucketMultiple(
      // @ts-ignore
      addFromBucketReqBody);
    },
    async createMedia(addFromBucketResponses) {
      const mediaCreationPromises = addFromBucketResponses.map(mediaRes => {
        const driveId = mediaRes.userFileId;
        // Create media
        return this.$api.cms.media.create(driveId);
      });
      return await Promise.all(mediaCreationPromises);
    },
    async submit() {
      var _input$files;
      // Have fun reading this, make sure to have some holy water by your side
      this.loading = true;
      const input = this.$refs.upload;
      const length = input === null || input === void 0 ? void 0 : (_input$files = input.files) === null || _input$files === void 0 ? void 0 : _input$files.length;
      if (!length) {
        this.showInfoToast('core.notifications.noMediaSelected');
        this.loading = false;
        return;
      }
      if (length > 10) {
        this.showInfoToast('core.notifications.tooManyFilesAtOnce');
        this.loading = false;
        return;
      }
      const files = Array.from(input.files);
      let token = null;
      try {
        await this.$recaptcha.reset();
        token = await this.$recaptcha.getResponse();
        await this.$recaptcha.reset();
      } catch (e) {
        console.log(e);
        this.$toast.error('Recaptcha error');
        this.loading = false;
        return;
      }
      const fileNames = files.map(file => ({
        filename: file.name
      }));

      // Get upload-to-bucket urls
      const uploadUrls = await this.$api.media.file.getMultipleUploadUrls({
        files: fileNames,
        'g-recaptcha-response': token
      });
      if (uploadUrls.errored) {
        this.loading = false;
        this.showErrorToast('error.uploadUrlFetchFailed');
        return;
      }

      // Convert each file to ArrayBuffer
      const convertedFiles = await this.readAllFiles(files);
      if (!(convertedFiles !== null && convertedFiles !== void 0 && convertedFiles.length)) {
        this.loading = false;
        return;
      }

      // Upload ArrayBuffer files to bucket
      const uploadToBucketResponses = await this.uploadFilesToBucket(files,
      // @ts-ignore
      convertedFiles, uploadUrls);
      if (!(uploadToBucketResponses !== null && uploadToBucketResponses !== void 0 && uploadToBucketResponses.length)) {
        this.loading = false;
        this.showErrorToast('error.uploadToBucketFailed');
        return;
      }

      // Add from bucket to cms media
      const mediaResponses = await this.addFromBucketToMedia(files, uploadUrls);
      if (mediaResponses !== null && mediaResponses !== void 0 && mediaResponses.errored) {
        this.loading = false;
        this.showErrorToast('error.addFromBucketFailed');
        return;
      }

      // Create media
      const mediaCreationResponses = await this.createMedia(mediaResponses.data);
      if (!!mediaCreationResponses.find(res => res.errored)) {
        this.showInfoToast('core.notifications.mediaPartiallyUploaded');
      } else {
        this.showSuccessToast('core.notifications.uploaded');
      }
      this.loading = false;
      this.$emit("media-uploaded");
      this.$modal.hide(Modals.MediaUpload);
    },
    showInfoToast(tPath) {
      this.$toast.info(this.$t(tPath));
    },
    showSuccessToast(tPath) {
      this.$toast.success(this.$t(tPath));
    },
    showErrorToast(tPath) {
      this.$toast.error(this.$t(tPath));
    }
  },
  render() {
    const h = arguments[0];
    return h("modal", _mergeJSXProps([{
      "attrs": {
        "name": Modals.MediaUpload,
        "id": Modals.MediaUpload,
        "clickToClose": false,
        "height": 'auto'
      }
    }, {
      "on": {
        'before-open': () => this.resetForm()
      }
    }]), [h("form", {
      "class": 'p-2',
      "on": {
        "submit": preventDefault(this.submit)
      }
    }, [h("div", {
      "class": 'p-2 text-xl font-medium'
    }, [this.$at('core.modals.details')]), h("div", [h("input", {
      "ref": "upload",
      "attrs": {
        "type": "file",
        "multiple": true
      },
      "class": 'p-2'
    }), h("recaptcha"), this.uploadProgress === null ? this.loading ? h("div", {
      "class": 'p-2'
    }, [h(CmsSpinner)]) : h("div", {
      "class": 'p-2 flex justify-end space-x-2'
    }, [h(AdminButton, {
      "attrs": {
        "secondary": true
      },
      "on": {
        "click": () => this.$modal.hide(Modals.MediaUpload)
      }
    }, [this.$at('core.action.cancel')]), h(AdminButton, {
      "attrs": {
        "type": 'submit'
      }
    }, [this.$at('core.action.save')])]) : h("div", {
      "class": 'flex items-center p-2'
    }, [h("div", {
      "class": 'relative flex-grow h-2 bg-gray-200 mr-4'
    }, [h("div", {
      "class": 'absolute top-0 bottom-0 left-0 bg-blue-400',
      "style": {
        width: this.uploadProgress + '%'
      }
    })]), h("div", [this.uploadProgress + '%'])])])])]);
  }
});
export default GboxMediaUpload;